import React from 'react';
import './SplitLayout.css';

function SplitLayout({ rightContent, children, panelWidthPercent = 30, onResize }) {
  const widthPercent = typeof panelWidthPercent === 'number' ? panelWidthPercent : 30;

  const scrollbarGap = 10; /* px reserved at viewport right for main scrollbar */

  return (
    <div className="split-layout-wrap">
      <div
        className="split-layout"
        // style={{ marginRight: `calc(${scrollbarGap}px + 6px + ${widthPercent}%)` }}
      >
        <div className="split-layout-main">
          {children}
        </div>
      </div>
      <div
        className="split-layout-resizer"
        style={{ right: `calc(${scrollbarGap}px + ${widthPercent}%)` }}
        onMouseDown={onResize || undefined}
        role="separator"
        aria-orientation="vertical"
        aria-valuenow={widthPercent}
      />
      <div
        className="split-layout-panel"
        style={{ width: `${widthPercent}%`, right: `${scrollbarGap}px` }}
      >
        {rightContent}
      </div>
    </div>
  );
}

export default SplitLayout;
